import { render, staticRenderFns } from "./ListOfCompanies.vue?vue&type=template&id=40bb23e4&scoped=true&"
import script from "./ListOfCompanies.vue?vue&type=script&lang=js&"
export * from "./ListOfCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bb23e4",
  null
  
)

export default component.exports